<div id="kt_app_footer" class="app-footer">
  <div
    class="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3"
  >
    <div class="text-gray-900 order-2 order-md-1">
      <span class="text-muted fw-semibold me-1">{{ currentYear }}&copy;</span>
      <a
        target="_blank"
        id="toastButton"
        class="btn btn-sm btn-muted text-gray-800 text-hover"
        >Dialogic</a
      >
    </div>
  </div>
</div>
